import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { Dialog } from '@monjin/vue-toolkit';

import { claimInterestCheckInvitation, claimInvitation, findInvitation } from '@api/claimInvitation';
import { matchError } from '@api/util';
import { UserData } from '@model/invitation';

import WithRender from './InviteOneway.html';

@WithRender
@Component({})
export default class InviteOneway extends Vue {

    public $refs: {
        dialog: Dialog;
    };

    public userInfo: UserData | null = null;
    public inviteCode: string = '';
    public errorMessage: string = '';
    public unknownError: boolean = false;
    public loading: boolean = true;
    public claimError: string = '';

    public get interestCheckInvite() {
        return this.userInfo ? this.userInfo.isInterestCheckInvite : false;
    }

    public get canContinueOnMobile() {
        return this.userInfo ? this.userInfo.canContinueOnMobile : true;
    }

    public get interestCheckClass(): string {
        return this.interestCheckInvite ? 'invitation--interest-check' : '';
    }

    public created() {
        this.inviteCode = this.$route.params.inviteCode;

        findInvitation(this.inviteCode)
            .then((data) => {
                this.loading = false;
                this.userInfo = data;
            })
            .catch(matchError({
                // 409 means interview already is progress
                409: (response: any) => {
                    const error = JSON.parse(response.body);
                    this.errorMessage = error.message;
                    this.loading = false;
                },

                // 410 means mostly this JD is probably expired or invite is cancelled by tenant
                410: () => {
                    const message = `This position is no longer active, thank you for your interest.<br/>
                                    For any further queries please contact your coordinator or email us at
                                    <a href="mailto:support@monjin.com">support@monjin.com</a>`;
                    this.errorMessage = message;
                    this.loading = false;
                },
                anyError: () => {
                    const message = 'Something went wrong!';
                    this.errorMessage = message;
                    this.unknownError = true;
                    this.$snackbar.error({ message });
                    this.loading = false;
                }
            }));
    }

    public changeRoute() {
        this.loading = true;

        claimInvitation(this.inviteCode)
            .then((data) => {

                if (this.userInfo && this.userInfo.isInterestCheckInvite) {
                    this.manageInterestCheckInvite();
                    return;
                }

                window.location.href = `/conclave/${data.videoActivityId}/activity`;

            })
            .catch(matchError({

                // 409 means maintenance activity is scheduled
                // and you cannot proceed to interview
                409: (response) => {
                    this.claimError = JSON.parse(response.body as any).message;
                    this.loading = false;
                    this.$refs.dialog.open();
                },

                anyError: () => {
                    this.loading = false;
                    this.$snackbar.error({ message: `Due to some problem we could not start your interview right now.
                        Please try again after some time.` });
                }
            }));
    }

    public manageInterestCheckInvite() {

        const defaultErrorMessage = 'Due to some problem we could not initiate your interest check.';
        const defaultErrorFn = (response) => {
            this.loading = false;
            this.$snackbar.error({ message: response.body.message || defaultErrorMessage });
        };

        claimInterestCheckInvitation(this.userInfo!.inviteId)
            .then(() => window.location.href = `/orbit/interest-check/${this.userInfo!.inviteId}`)
            .catch(matchError({

                // @ts-ignore
                422: (response: any) => {

                    if (response.body.code === 1403) {
                        this.loading = false;
                        this.$snackbar.error({ message: response.body.errors[0].message || defaultErrorMessage });
                        return;
                    }

                    defaultErrorFn(response);
                },

                anyError: defaultErrorFn

            }));
    }
}
